"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusWithin = exports.focusSource = void 0;
var focus_source_1 = require("./focus-source");
Object.defineProperty(exports, "focusSource", { enumerable: true, get: function () { return __importDefault(focus_source_1).default; } });
// Unspecified error on Internet Explorer with document.activeElement
// https://github.com/reactjs/react-tabs/issues/193
var canUseActiveElement = typeof window !== 'undefined' &&
    window.document &&
    // eslint-disable-next-line valid-typeof
    typeof window.document.activeElement !== 'unknown';
// inspired by https://gist.github.com/aFarkas/a7e0d85450f323d5e164
var focusWithin = function () {
    var slice = [].slice;
    var removeClass = function (elem) {
        elem.classList.remove('focus-within');
    };
    var update = (function () {
        var running;
        var last;
        var action = function () {
            var element = canUseActiveElement ? document.activeElement : null;
            running = false;
            if (last !== element) {
                last = element;
                slice
                    .call(document.getElementsByClassName('focus-within'))
                    .forEach(removeClass);
                while (element && element.classList) {
                    element.classList.add('focus-within');
                    element = element.parentNode;
                }
            }
        };
        return function () {
            if (!running) {
                requestAnimationFrame(action);
                running = true;
            }
        };
    })();
    document.addEventListener('focus', update, true);
    document.addEventListener('blur', update, true);
    update();
    return {
        disengage: function () {
            document.removeEventListener('focus', update, true);
            document.removeEventListener('blur', update, true);
        },
    };
};
exports.focusWithin = focusWithin;
//# sourceMappingURL=focus.js.map